import { Component, OnInit } from '@angular/core';
import { TemplateApiService } from 'src/app/api/services/template-api.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { ActionsMenu } from 'src/app/components/common-actions/common-actions.component';
import { FeaturesService } from 'src/app/components/plans/features.service';
import { TemplatesService } from 'src/app/presentations/services/templates.service';
import { BaseEditableComponent } from 'src/app/shared/components/base-editable/base-editable.component';
import { environment } from 'src/environments/environment';
import { AlertsService } from '../../services/alerts.service';
@Component({
    selector: 'alerts',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.scss'],
    standalone: false
})
export class AlertsComponent extends BaseEditableComponent<any> implements OnInit {

  ALERTS_WS_URL = environment.ALERTS_WS_URL;
  showFilters: boolean = false;
  showButtons: boolean = false;
  featureAvailable: boolean;
  templates: any[] = [];
  actions: ActionsMenu = {};

  WARNING_NOT_SUBSCRIBED = 'This feature requires an active subscription.';
  WARNING_NOT_AVAILABLE = 'This feature is not available on your current plan.';
  WARNING_MISSING_TEMPLATE = 'Please select an alerts template.';

  _alertsOn = false;
  get alertsOn(): boolean {
    return this._alertsOn;
  }
  set alertsOn(value: boolean) {
    this._alertsOn = value;
    this._updateEnabled();

    if (this.actions && this.actions.saveAction) {
      this.actions.saveAction.disabled = this.saveButtonDisabled;
    }
  }

  _termsAccepted = false;
  get termsAccepted(): boolean {
    return this._termsAccepted;
  }
  set termsAccepted(value: boolean) {
    this._termsAccepted = value;
    this._updateEnabled();

    if (this.actions && this.actions.saveAction) {
      this.actions.saveAction.disabled = this.saveButtonDisabled;
    }
  }

  get alertUrl() {
    return this.ALERTS_WS_URL + '?id=' + this.alertsService.alertKey;
  }

  allowedSendersCsv = '';
  allowedHandlingCodesCsv = '';
  allowedEventCodesCsv = '';

  constructor(
    public alertsService: AlertsService,
    private featuresService: FeaturesService,
    private templatesService: TemplatesService,
    private templateApiService: TemplateApiService,
    public userStateService: UserStateService,
  ) {
    super();
  }

  get saveButtonDisabled(): boolean {
    return this.alertsService.savingAlerts ||
      !this.featureAvailable ||
      (!this.termsAccepted && this.alertsOn) ||
      (this.alertsService.missingTemplate && this.alertsService.alertSettings.templateProductCode === '');
  }

  ngOnInit(): void {
    this.alertsService.loadSettings();
    this.featureAvailable = this.featuresService.isFeatureAvailable(FeaturesService.FEATURE_ALERTS);
    if (this.alertsService.alertSettings?.enabled) {
      this._termsAccepted = true;
      this._alertsOn = true;
      this.showButtons = true;
    }

    this.allowedSendersCsv = this.alertsService.alertSettings.allowedSenders ? this.alertsService.alertSettings.allowedSenders.join(',') : '';
    this.allowedHandlingCodesCsv = this.alertsService.alertSettings.allowedHandlingCodes ? this.alertsService.alertSettings.allowedHandlingCodes.join(',') : '';
    this.allowedEventCodesCsv = this.alertsService.alertSettings.allowedEventCodes ? this.alertsService.alertSettings.allowedEventCodes.join(',') : '';

    this.actions = {
      saveAction: {
        id: 'saveButton',
        label: 'Save',
        action: () => this.saveSettings(),
        disabled: this.saveButtonDisabled,
        requireRole: 'ua'
      },
      cancelAction: {
        id: 'cancelButton',
        label: 'Cancel',
        action: () => {
          this.bypassUnsavedChanges();
          this.stateService.go('apps.displays.list');
        }
      }
    };

    if (this.alertsOn) {
      this._loadTemplates();
    }
    this.oldObject = this.cloneDeep(this.alertsService.alertSettings);
  }

  canDeactivate(): boolean {
    return this.isDeepEqual(this.oldObject, this.alertsService.alertSettings);
  }

  private _setDefaultTemplate() {
    if (
      !this.alertsService.alertSettings.templateProductCode &&
      !this.alertsService.alertSettings.presentationId &&
      this.templates.length
    ) {
      this.alertsService.alertSettings.templateProductCode = this.templates[0].productCode;
    }
  }

  private _loadTemplates() {
    if (this.templatesService.capAlerts?.length) {
      this.templates = this.templatesService.capAlerts;
      this._setDefaultTemplate();
    } else {
      this.alertsService.savingAlerts = true;
      this.templateApiService.listTemplates({
        count: 10,
        filter: 'templateContentTypes:=Common Alert Protocol'
      }).then((result) => {
        this.templatesService.capAlerts = result.items;
        this.templates = result.items;
        this._setDefaultTemplate();
      }).finally(() => {
        setTimeout(() => {
          this.alertsService.savingAlerts = false;
        });
        this.oldObject = this.cloneDeep(this.alertsService.alertSettings);
      });
    }
  }

  private _updateEnabled() {
    if (this._termsAccepted && this._alertsOn) {
      this.alertsService.alertSettings.enabled = true;
    } else {
      this.alertsService.alertSettings.enabled = false;
    }
  }

  toggleAlerts() {
    this.alertsOn = !this.alertsOn;
    if (this.alertsOn && !this.templates.length) {
      this._loadTemplates();
    }
  }

  showUpgradePlanModal() {
    this.featuresService.showUpgradePlanModal(FeaturesService.FEATURE_ALERTS);
  }

  parseCsvList(csv: string, fieldName: string) {
    if (!this.alertsService.alertSettings[fieldName]) {
      this.alertsService.alertSettings[fieldName] = [];
    }

    const list = this.alertsService.alertSettings[fieldName];
    const items = csv.trim() === '' ? [] : csv.split(',');
    list.splice(0, list.length);
    items.forEach((item) => {
      list.push(item.trim());
    });
  }

  getCheckboxList(fieldName: string, key: string) {
    return this.alertsService.alertSettings[fieldName] && (this.alertsService.alertSettings[fieldName].indexOf(key) >= 0);
  }

  setCheckboxList(fieldName: string, key: string, value?: boolean) {

    if (!this.alertsService.alertSettings[fieldName]) {
      this.alertsService.alertSettings[fieldName] = [];
    }

    const fieldValue = this.alertsService.alertSettings[fieldName];
    const index = fieldValue.indexOf(key);
    if (value === undefined && index < 0 || value) {
      fieldValue.push(key);
    } else {
      fieldValue.splice(index, 1);
    }
  }

  saveSettings() {
    this.alertsService.save().then(() => {
      this.showButtons = !!this.alertsService.alertSettings?.enabled;
      this.oldObject = this.cloneDeep(this.alertsService.alertSettings);
    });
  }

  copyAlertUrl() {
    window.navigator.clipboard.writeText(this.alertUrl);
    this.modalService.showMessage('Web Service URL Copied', 'The URL has been copied to your clipboard.');
  }

  resetAlertUrl() {
    if (this.featureAvailable) {
      this.modalService.confirm(
        'Reset Web Service URL?',
        'If you reset your Web Service URL, you will need to provide the new URL to your CAP Alerts provider, otherwise your alerts will stop working.',
        'I Understand',
        'Cancel',
        'urlResetButton'
      ).then(() => {
        this.alertsService.regenerateAlertKey();
      }).catch(() => { });
    }
  }

  setTemplate(productCode: string | boolean) {
    if (productCode === true) {
      this.alertsService.alertSettings.templateProductCode = '';
      this.alertsService.changePresentation();
    } else {
      this.alertsService.alertSettings.presentationId = '';
      this.alertsService.alertSettings.presentationName = '';
      if (productCode) {
        this.alertsService.alertSettings.templateProductCode = productCode;
      } else if (this.templates?.length) {
        this.alertsService.alertSettings.templateProductCode = this.templates[0].productCode;
      }
    }
  }

  onDefaultExpiryInput(event: any) {
    const value = parseFloat(event.target.value);
    if (value < 0 || isNaN(value)) {
      event.target.value = 0;
      this.alertsService.alertSettings.defaultExpiry = 0;
    } else {
      this.alertsService.alertSettings.defaultExpiry = value;
    }
  }

  onDefaultExpiryKeydown(event: KeyboardEvent) {
    // Prevent typing minus sign, plus sign, and 'e' (scientific notation)
    if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  }
}
